export default __webpack_public_path__ + "static/media/all.630b3ab5.png";